/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type invitationPanelQueryVariables = {
    readonly id: string;
};
export type invitationPanelQueryResponse = {
    readonly invitation: {
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly invitation: {
            readonly id: string;
            readonly description: string | null;
            readonly person: string | null;
            readonly entity: string | null;
            readonly expiryDate: unknown | null;
            readonly created: unknown | null;
            readonly __typename: string;
        } | null;
    } | null;
};
export type invitationPanelQuery = {
    readonly response: invitationPanelQueryResponse;
    readonly variables: invitationPanelQueryVariables;
};



/*
query invitationPanelQuery(
  $id: ID!
) {
  invitation(id: $id) {
    hasErrors
    errors {
      id
      location
    }
    invitation {
      id
      description
      person
      entity
      expiryDate
      created
      __typename
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "invitation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "InvitationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invitation",
        "storageKey": null,
        "args": null,
        "concreteType": "Invitation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "person",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "entity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "expiryDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "created",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "invitationPanelQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "invitationPanelQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "invitationPanelQuery",
    "id": null,
    "text": "query invitationPanelQuery(\n  $id: ID!\n) {\n  invitation(id: $id) {\n    hasErrors\n    errors {\n      id\n      location\n    }\n    invitation {\n      id\n      description\n      person\n      entity\n      expiryDate\n      created\n      __typename\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '5260b69bd8e97375f6772c0c270fa424';
export default node;
